import { useCallback, useContext, useEffect, useState } from 'react';

// Hooks
import useInterval from '../../../../packages/hooks/useInterval';

// Contexts
import FootballApiContext from '../contexts/FootballApiContext';

// Constants
import refreshTimes from '../../../../packages/constants/refreshTimes';

// Types
import { IFootballLineupsConfig, IMatchEventSnakeCase, SDKOptions } from '../../../../packages/types';
import { IGeneralSubscriberInfo } from '../../../../packages/constants/subscribeTypes';

interface IUseTimelineArgs extends IGeneralSubscriberInfo {
  dataMatchId?: IFootballLineupsConfig['dataMatchId'];
  dataRefreshTime?: IFootballLineupsConfig['dataRefreshTime'];
  sdkOptions: SDKOptions;
}

export default function useTimeline({ dataMatchId, dataRefreshTime, sdkOptions }: IUseTimelineArgs) {
  const [timeline, setTimeline] = useState<IMatchEventSnakeCase[]>([]);
  const { $timeline } = useContext(FootballApiContext);
  const interval = refreshTimes[dataRefreshTime || 'never'];
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchTimeline = useCallback(
    (manageLoader: boolean) => {
      if (dataMatchId) {
        manageLoader && setIsLoading(true);

        $timeline
          ?.getTimeline({ idOrSlug: dataMatchId }, sdkOptions)
          ?.then((res) => {
            manageLoader && setIsLoading(false);

            if (res?.events) {
              setTimeline(res.events);
            }
          })
          .catch((error: unknown) => {
            console.error(error);
          });
      }
    },
    [$timeline, dataMatchId],
  );

  const refetchWidgetData = useCallback(() => {
    fetchTimeline(false);
  }, [fetchTimeline]);

  useInterval(() => {
    refetchWidgetData();
  }, interval);

  useEffect(() => {
    fetchTimeline(true);
  }, [fetchTimeline]);

  return {
    showWidget: true,
    widgetData: { timeline, isLoading },
    refetchWidgetData,
  };
}
